import React from "react";
import { FaFilePdf } from "react-icons/fa";
import { FiBookOpen, FiExternalLink, FiRotateCw } from "react-icons/fi";

import Reveal from "../../../components/ui/Reveal";

import { cn } from "../utils/publicationsUtils";

export default function PublicationsSummary({
  loading,
  publications = [],
  selectedId,
  onSelect,
  onRefresh,
}) {
  return (
    <Reveal>
      <section className="rounded-[2rem] border border-slate-200 bg-white p-5 shadow-sm dark:border-slate-800 dark:bg-slate-950 sm:p-6">
        <div className="flex flex-wrap items-start justify-between gap-4">
          <div>
            <p className="flex items-center gap-2 text-xs font-bold uppercase tracking-[0.18em] text-[#1277B9]">
              <FiBookOpen className="h-4 w-4" />
              Sommaire
            </p>
            <h2 className="mt-2 text-xl font-bold text-slate-950 dark:text-white">
              Publications disponibles
            </h2>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Sélectionnez une publication pour afficher son détail.
            </p>
          </div>

          <button
            type="button"
            onClick={onRefresh}
            disabled={loading}
            className="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 text-sm font-bold text-slate-700 transition hover:bg-slate-50 disabled:cursor-not-allowed disabled:opacity-60 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800"
          >
            <FiRotateCw className={cn("h-4 w-4", loading && "animate-spin")} />
            Actualiser
          </button>
        </div>

        {loading && (
          <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {Array.from({ length: 6 }).map((_, index) => (
              <div
                key={index}
                className="h-24 animate-pulse rounded-3xl bg-slate-100 dark:bg-slate-900"
              />
            ))}
          </div>
        )}

        {!loading && publications.length > 0 && (
          <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {publications.map((publication, index) => {
              const active = publication.id === selectedId;

              return (
                <button
                  key={publication.id}
                  type="button"
                  onClick={() => onSelect(publication.id)}
                  className={cn(
                    "group text-left rounded-3xl border p-4 transition",
                    active
                      ? "border-[#1277B9] bg-[#1277B9]/5 shadow-sm"
                      : "border-slate-200 bg-white hover:border-[#1277B9]/50 hover:bg-sky-50 dark:border-slate-800 dark:bg-slate-950 dark:hover:bg-slate-900"
                  )}
                >
                  <div className="flex items-start gap-3">
                    <span
                      className={cn(
                        "inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-2xl text-sm font-bold",
                        active
                          ? "bg-[#1277B9] text-white"
                          : "bg-slate-100 text-slate-500 dark:bg-slate-900 dark:text-slate-300"
                      )}
                    >
                      {index + 1}
                    </span>

                    <div className="min-w-0">
                      <p
                        className={cn(
                          "line-clamp-2 text-sm font-bold leading-snug",
                          active
                            ? "text-[#1277B9]"
                            : "text-slate-800 dark:text-slate-100"
                        )}
                      >
                        {publication.title}
                      </p>

                      <div className="mt-2 flex flex-wrap items-center gap-2">
                        {publication.dateLabel && (
                          <span className="text-xs font-semibold text-slate-400">
                            Publié le {publication.dateLabel}
                          </span>
                        )}

                        {publication.isPdf && (
                          <span className="inline-flex items-center gap-1 rounded-full bg-red-50 px-2 py-0.5 text-[11px] font-bold text-red-700 dark:bg-red-500/10 dark:text-red-300">
                            <FaFilePdf className="h-3 w-3" />
                            PDF
                          </span>
                        )}

                        {publication.hasLink && !publication.isPdf && (
                          <span className="inline-flex items-center gap-1 rounded-full bg-slate-100 px-2 py-0.5 text-[11px] font-bold text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                            <FiExternalLink className="h-3 w-3" />
                            Lien
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        )}
      </section>
    </Reveal>
  );
}